import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-pet-rehome-modal',
  templateUrl: './pet-rehome-modal.component.html',
  styleUrls: ['./pet-rehome-modal.component.scss']
})
export class PetRehomeModalComponent implements OnInit {
  @Input() petName: string;

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
